import { Route, Switch } from 'react-router-dom'
import React, { FC } from 'react'
import valuesIn from 'lodash/valuesIn'
import _ from 'lodash'
import {TRANSLATE_LANGUAGES} from 'src/common/razzle-platform-translate/configs'
import { AuthenticationProvider } from "src/common/razzle-platform-user/Authentication"
import { AlertProvider } from "src/common/razzle-platform-components/alert"
import MaterialThemeProvider from 'src/common/razzle-platform-components/theme/MaterialThemeProvider'
import NotFound from 'src/common/razzle-platform-components/errors/NotFound/NotFound'
import { ProductConfig } from 'src/modules/product/ProductConfig'
import { UserConfig } from "src/modules/user/UserConfig"


const routeConfigs = [ProductConfig, UserConfig]


export type IPageSettings = {
	layout?: {
		navbar: {
			display: boolean
		}
		toolbar: {
			display: boolean
		}
	}
}

export type IRoute<T> = {
	path: string
	component: FC<T>
	props?: T
}

export type IModuleConfig = {
	routes: Record<string, IRoute<unknown>>
}


const generateRoutesFromConfigs = (configs: IModuleConfig[]) => {
	let allRoutes: IRoute<unknown>[] = []
	configs.forEach((config: IModuleConfig) => {
		const routes: IRoute<unknown>[] = valuesIn(config.routes)
		_.forEach(routes, (route: IRoute<unknown>) => {
			allRoutes.push(route)
			// create additional routes for use them in the translation
			_.forEach(TRANSLATE_LANGUAGES, lang => {
				allRoutes.push({ ...route, path: `/:locale(${lang})${route.path}`})
			})
		})
	})

	return allRoutes
}


export const routes: Partial<IRoute<unknown>>[] = generateRoutesFromConfigs(routeConfigs as any)



const Routes = () => {
	return (
		<Switch>
			{routes.map((route: any, index: number) => {
				return (
					<Route key={index} path={route.path} exact={true} render={props => (<route.component {...route.props} key={props.match.url} />)} />
				)
			})}
			<Route path="*">
				<NotFound />
			</Route>
		</Switch>
	)
}



const App = () => {

	return (
		<MaterialThemeProvider>
			<AlertProvider>
				<AuthenticationProvider>
					<Routes />
				</AuthenticationProvider>
			</AlertProvider>	
		</MaterialThemeProvider>

	)
}

export default App
